import {SurveyElementValidator, SurveyValueType} from 'core/SurveyModels'

export class SurveyElementValidatorService {
  private static emailExp = new RegExp(
    /^[a-z0-9.!#$%&'*+\-/=?^_`{|}~]{1,64}@[a-z0-9\-_]+?\.[a-z]{2,32}(\.[a-z]{2,32})?$/i
  )
  private static phoneExp = new RegExp(/^9725[0123458]\d{7}$/)

  validate(validator: SurveyElementValidator, value: SurveyValueType) {
    switch (validator.type) {
      case 'phone':
        return SurveyElementValidatorService.phone(validator.arguments, value)
      case 'email':
        return SurveyElementValidatorService.email(validator.arguments, value)
      // case 'required':
      //   return SurveyElementValidatorService.required(validator.arguments, value)
    }
  }

  private static phone(_: unknown, value: SurveyValueType) {
    if (typeof value !== 'string') {
      return false
    }
    return this.phoneExp.test(value)
  }

  private static email(_: unknown, value: SurveyValueType) {
    if (typeof value !== 'string') {
      return false
    }
    return this.emailExp.test(value)
  }

  // private static required(_: any, value: SurveyValueType) {
  //   if (Array.isArray(value)) {
  //     return value.length > 0
  //   }
  //   if (typeof value === 'string') {
  //     return value.trim().length > 0
  //   }
  //   return !!value
  // }
}
